module.exports = __webpack_public_path__ + "static/media/finish-line-purple.1038a16d.png";